/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import AddIcon from '@atlaskit/icon/core/migration/add--editor-add';
import { inviteTeamWrapperStyles } from './styles';
var ID = function ID(props) {
  return jsx(Fragment, null, props.children);
};
export var InviteToEditButton = function InviteToEditButton(props) {
  var Component = props.Component,
    onClick = props.onClick,
    selected = props.selected,
    title = props.title;
  var iconBefore = React.useMemo(function () {
    return jsx(AddIcon, {
      label: title
    });
  }, [title]);
  if (!Component && !onClick) {
    return null;
  }
  var Wrapper = Component ? Component : ID;
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: inviteTeamWrapperStyles
    }, jsx(Wrapper, null, jsx(ToolbarButton
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
      className: "invite-to-edit",
      onClick: onClick,
      selected: selected,
      title: title,
      titlePosition: "bottom",
      iconBefore: iconBefore
    })))
  );
};